import React from 'react';
import { observer } from 'mobx-react';

import routerStore from '@app/src/common/store/RouterStore';
import sidebarStore from '@app/src/common/components/sidebar/SidebarStore';

import { EXTERNAL_MODULES, SIDEBAR_ROUTES } from './constants/navigationRoutes';
import { buildModuleEntries } from './moduleEntries';
import NavigationItem from './NavigationItem';

import './Navigation.scss';

const Navigation = () => {
  const moduleEntries = buildModuleEntries(
    routerStore.routes,
    SIDEBAR_ROUTES,
    EXTERNAL_MODULES
  );

  return (
    <nav className="navigation">
      <ul className="navigation__list">
        {moduleEntries.map(entry => (
          <li
            key={entry.key}
            id={`navigationItem${entry.key}`}
            className="navigation__item"
          >
            <NavigationItem
              entry={entry}
              className="navigation__link"
              location={routerStore.location}
              collapsed={sidebarStore.collapsed}
            />
          </li>
        ))}
      </ul>
    </nav>
  );
};

export default observer(Navigation);
